import React from 'react';
import './Btn1.css';
import btnImg from '../../asserts/btn.png';
import { useMusic } from '../layout/MusicContext';

const Btn1 = (props) => {
  const { playClick } = useMusic();
  const handleClick = (e) => {
    playClick();
    if (props.onClick) props.onClick(e);
  };
  return (
    <button className="btn1" onClick={handleClick}>
      <img className="btn1-bg" src={btnImg} alt="" />
      <span className="btn1-text">{props.btnt}</span>
    </button>
  );
};

export default Btn1;